// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".epb0n{margin-top:30px}.Hnyk3{margin-top:15px}._3EZrE{text-align:right;width:100%;position:absolute;top:60px}", ""]);
// Exports
exports.locals = {
	"root": "epb0n",
	"h4": "Hnyk3",
	"close": "_3EZrE"
};
module.exports = exports;
